<template>
  <d-modal
    size="lg"
    @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('order.boxCommentsPopup.title') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="p-0">
      <table
        v-if="items.length"
        class="table">
        <thead>
          <tr>
            <th style="width: 220px;" class="pl-5">{{ $t('order.boxCommentsPopup.createdAt') }}</th>
            <th style="width: 120px;">{{ $t('order.boxCommentsPopup.operation') }}</th>
            <th style="width: calc(100% - 340px)">{{ $t('order.boxCommentsPopup.description') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, index) of items"
            :key="'logs-row-' + index">
            <td class="pl-5">{{ row.created_at }}</td>
            <td>
              <d-badge
                v-if="row.type === 'COLLECTION'"
                theme="warning">
                {{ $t('order.boxCommentsPopup.operationCollection') }}
              </d-badge>

              <d-badge
                v-if="row.type === 'VERIFICATION'"
                theme="success">
                {{ $t('order.boxCommentsPopup.operationVerification') }}
              </d-badge>

              <d-badge
                v-if="row.type === 'RETURN'"
                theme="danger">
                {{ $t('order.boxCommentsPopup.operationReturn') }}
              </d-badge>
            </td>
            <td>
              {{ row.description }}
            </td>
          </tr>
        </tbody>
      </table>
      <d-alert
        :show="!items || !items.length"
        theme="warning"
        class="text-center">
        {{ $t('order.boxCommentsPopup.noComments') }}
      </d-alert>
    </d-modal-body>
  </d-modal>
</template>

<script>
export default {
  name: 'order-box-products-comments-popup',
  props: [
    'dataToDisplay'
  ],
  data () {
    return {
      items: []
    };
  },
  mounted () {
    let keys = Object.keys(this.dataToDisplay);

    for (let i = 0; i < keys.length; i++) {
      if (keys[i] !== 'product_code') {
        let row = this.dataToDisplay[keys[i]];

        if (row.collections.length) {
          for (let j = 0; j < row.collections.length; j++) {
            if (row.collections[j].description) {
              this.items.push({
                type: 'COLLECTION',
                created_at: row.collections[j].created_at,
                description: row.collections[j].description
              });
            }
          }
        }

        if (row.verifications.length) {
          for (let j = 0; j < row.verifications.length; j++) {
            if (row.verifications[j].description) {
              this.items.push({
                type: 'VERIFICATION',
                created_at: row.verifications[j].created_at,
                description: row.verifications[j].description
              });
            }
          }
        }

        if (row.returns && row.returns.length) {
          for (let j = 0; j < row.returns.length; j++) {
            if (row.returns[j].description) {
              this.items.push({
                type: 'RETURN',
                created_at: row.returns[j].created_at,
                description: row.returns[j].description
              });
            }
          }
        }
      }
    }

    this.items.sort((itemA, itemB) => {
      let dateA = new Date(itemA.created_at);
      let dateB = new Date(itemB.created_at);
      return dateB - dateA;
    });
  },
  methods: {
    handleClose () {
      this.$bus.$emit('order-creator-box-products-comments-popup-close');
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
